import { useEffect, useMemo } from 'react';
import { TResponsiblePerson } from '~/modules/remote-banking-contacts/type.ts';
import { Box, Grid, Typography } from '@mui/material';
import { styles } from '~/modules/styles';
import { ResponsiblePersonBlockForm } from '~/modules/remote-banking-contacts/components/ResponsiblePersonBlockForm.tsx';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import { initialValuesResponsiblePersons } from '~/modules/remote-banking-contacts/initialValues.ts';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { RootState } from '~/store/store.ts';

export const RemoteBankingContactsResponsiblePersonsForm = () => {
  const { reset } = useFormContext();

  const { formPersonsInfo, formPersons } = useSelector(
    (state: RootState) => state.remoteBankingContacts
  );
  const { directors, someone } = initialValuesResponsiblePersons(formPersons);
  const sortedPersons = useMemo(() => [...directors, ...someone], [directors, someone]);

  useEffect(() => {
    if (formPersonsInfo && formPersons?.length) {
      reset({
        formPersonsInfo,
        formPersons: sortedPersons,
      });
    }
  }, [formPersonsInfo, formPersons]);

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormInput
            fullWidth
            disabled
            name="formPersonsInfo.contragentIdentifier"
            label="ЄДРПОУ / РНОКПП"
            placeholder="Введіть ЄДРПОУ або РНОКПП"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormInput
            fullWidth
            disabled
            name="formPersonsInfo.name"
            label="Найменування / ПІБ"
            placeholder="Введіть найменування або ПІБ"
          />
        </Grid>
      </Grid>
      {directors.length > 0 && (
        <>
          <Typography sx={styles.cardFormTitle}>Керівник</Typography>
          {directors.map((director) => {
            const index = sortedPersons.findIndex((p) => p.id === director.id);
            return (
              <ResponsiblePersonBlockForm
                key={director.id}
                parameterValue={director as TResponsiblePerson}
                index={index}
              />
            );
          })}
        </>
      )}
      {someone.length > 0 && (
        <>
          {someone.map((person, i) => {
            const index = sortedPersons.findIndex((p) => p.id === person.id);
            return (
              <Box key={person.id}>
                <Typography sx={styles.cardFormTitle}>Відповідальна особа {i + 1}</Typography>
                <ResponsiblePersonBlockForm
                  parameterValue={person as TResponsiblePerson}
                  index={index}
                />
              </Box>
            );
          })}
        </>
      )}
    </Box>
  );
};
